import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=c757b0b8&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=c757b0b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c757b0b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c757b0b8')) {
      api.createRecord('c757b0b8', component.options)
    } else {
      api.reload('c757b0b8', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=c757b0b8&scoped=true", function () {
      api.rerender('c757b0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/contract/components/Documents.vue"
export default component.exports